export const formatUrlName = function (name) {
  return name.replace(/ /g, '_').replace(/\//g, '_').toLowerCase()
}